import { createInMemoryAtom } from '@exodus/atoms';
export function createSoftwareWalletPublicKeysAtom() {
    return createInMemoryAtom({ defaultValue: Object.create(null) });
}
const softwareWalletPublicKeysAtomDefinition = {
    id: 'softwareWalletPublicKeysAtom',
    type: 'atom',
    factory: createSoftwareWalletPublicKeysAtom,
};
export default softwareWalletPublicKeysAtomDefinition;
